<div class="central-content">
  <div class="heading-image mb-30">
  </div>

  <div class="unsupported-device__wrapper mx-auto p-30 text-center">
    <div class="vo-heading-bold-24 my-15" [innerHTML]="referenceDataLabels.UnsupportedDevicePageTitle | localizeLabel | toTrustedHtml"></div>
    <div class="vo-body-regular-14 my-30" [innerHTML]="referenceDataLabels.UnsupportedDevicePageDescription | localizeLabel | toTrustedHtml"></div>
  </div>
</div>
